import $ from "jquery"
import store from "../store"

class API{
    constructor(endpoint,router){
        this.endpoint=endpoint;
        this.router=router;
    }

    geApiUrl(){
        return store.state.config.meta.selfHost? "/api" : store.state.config.meta.apiUrl;
    }

    get url(){
       return this.geApiUrl()+"/"+this.endpoint;
    }

    get token(){
        var token= store.state.config.identity.token;
        return token;
    }

    async get(args,headers){
        return await Promise.resolve($.ajax({
            url:this.url,
            data:args,
            type:"get",
            headers:this.getHeaders(headers)
        })).catch(this.handleAuthError.bind(this));
    }

    async post(args,headers){
        var req= this.inferType(args);

        return await Promise.resolve($.ajax({
            url:this.url,
            type:"post",
            data:req.data,
            contentType:req.type,
            headers:this.getHeaders(headers)
        })).catch(this.handleAuthError.bind(this));
    }

    async put(args,headers){
        var req= this.inferType(args);

       return await Promise.resolve($.ajax({
            url:this.url,
            type:"put",
            data:req.data,
            contentType:req.type,
            headers:this.getHeaders(headers)
        })).catch(this.handleAuthError.bind(this));
    }

    async delete(args,headers){
        var req= this.inferType(args);

       return await Promise.resolve($.ajax({
            url:this.url,
            type:"delete",
            data:req.data,
            contentType:req.type,
            headers:this.getHeaders(headers)
        })).catch(this.handleAuthError.bind(this));
    }

    inferType(args){
        var data;
        var type;
        if(typeof(args)=="string"){
            data=args;
            type="application/x-www-form-urlencoded"
        }
        else{
            data=JSON.stringify(args);
            type="application/json";
        }

        return {data,type};
    }

    getHeaders(h){
        if(!h)
            h={};
        
        if(this.token && !this.authorization)
            h.authorization="Bearer "+this.token;

        return h;
    }

    handleAuthError(xhr){
        
        if(xhr.status==401){
            this.router.push({name:"login"});
        }
        return Promise.reject(xhr);
    }
}

export default {
    install:function(Vue){
        Vue.prototype.$api=function(x){
            var me=this;
            return new API(x,me.$router);
        }

    }
};

export {API as endpoint};